/**
 * File: useAppSidebarController.ts
 * Path: apps/admin/src/modules/layout/hooks/useAppSidebarController.ts
 * Description: What the sidebar shows: the signed-in user, the menu items their role may see, whether the
 * sidebar is open, and the sign-out and collapse actions.
 */

import { useMemo } from "react";
import { SIDEBAR_ITEMS, visibleNavItems } from "@idk/config";
import { useAuthMutations } from "@/modules/auth/hooks/useAuthMutations";
import { useRole } from "@/modules/auth/hooks/useRoleQueries";
import { useAuth } from "@/modules/auth/components/AuthProvider";
import { useUIStore } from "@/modules/app/hooks/useUiState";

export const useAppSidebarController = () => {
  const { user } = useAuth();
  const { can } = useRole();
  const { logout, isPending } = useAuthMutations();
  const { isSidebarCollapsed, toggleSidebar } = useUIStore();

  const isOpen = !isSidebarCollapsed;
  const userInitial = user?.email ? user.email.charAt(0).toUpperCase() : "U";

  const filteredItems = useMemo(() => visibleNavItems(SIDEBAR_ITEMS, can), [can]);

  return {
    email: user?.email,
    isOpen,
    userInitial,
    filteredItems,
    isPending,
    toggleSidebar,
    logout: () => logout(),
  };
};
